<div class="row justify-content-center p-5" *ngIf="caseloading || loadingCache">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>
  
<div class="row" *ngIf="page === 'create' && !caseloading && !loadingCache">
    <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12 p-3">
      <form>
        <div class="form-row">

            <div class="form-group col-12" >
                <label for="type">{{ 'pages.support.dashboard.fieldTitles.type' | translate }}</label>
                <select class="form-control" name="type" aria-describedby="type" [(ngModel)]="case.type" [ngClass]="{'has-danger': !case.type}">
                    <option></option>
                    <option value="{{tt}}" *ngFor="let tt of caseTypeCV">{{tt}}</option>
                </select>
            </div>

            <div class="form-group col-12">
                <label for="subject">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}</label>
                <input type="text" class="form-control" name="subject" id="subject" aria-describedby="Subject" [(ngModel)]="case.subject" [ngClass]="{'has-danger': !case.subject}">
            </div>

            <div class="form-group col-12">
                <label for="exampleInputTicketRef">{{ 'pages.support.dashboard.fieldTitles.description' | translate }}</label>
                <textarea class="form-control" id="desc" rows="10" name="desc" [(ngModel)]="case.description" [ngClass]="{'has-danger': !case.description}"></textarea>
            </div>

            <div class="form-group col-12" *ngIf="case.type == 'Incident'">
                <label for="priority">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}</label>
                <select class="form-control" name="priority" aria-describedby="priority" [(ngModel)]="case.priority" [ngClass]="{'has-danger': !case.priority}">
                    <option></option>
                    <option value="{{tt}}" *ngFor="let tt of casePriorityCV">{{tt}}</option>
                </select>
                <div class="alert alert-danger mt-2" role="alert" *ngIf="case.priority == '1 - Business Critical'">
                    <span class="alert-icon"><span class="visually-hidden"></span></span>
                    <p>{{ 'pages.support.dashboard.fieldTitles.priorityOneError' | translate }}<br><br>
                    Orange Cyberdefense Netherlands: +31 88 1234250<br>
                    Orange Cyberdefense Belgium: +32 78 77 00 24<br>
                    Orange Cyberdefense Denmark: +45 70 200 438<br>
                    Orange Cyberdefense Norway: +47 67 57 37 47<br>
                    Orange Cyberdefense Sweden: +46 40 60 60 640<br>
                    Orange Cyberdefense Sweden (Toll free): 0200 12 52 31<br>
                    Orange Cyberdefense United Kingdom: +44 208 338 9548<br>
                    Orange Cyberdefense Germany: +49 89 2000 1480 300<br>
                </p>
                  </div>
            </div>

            <div class="form-group col-12" *ngIf="case.type == 'Change Request'">
                <label for="changeType">{{ 'pages.support.dashboard.fieldTitles.changeType' | translate }}</label>
                <select class="form-control" name="changeType" aria-describedby="changeType" [(ngModel)]="case.changeType" [ngClass]="{'has-danger': !case.changeType}">
                    <option selected value="Standard Change">Standard Change</option>
                    <option value="Emergency Change">Emergency Change</option>
                </select>
            </div>

            <div class="form-group col-12">
                <label for="customerReference">{{ 'pages.support.dashboard.fieldTitles.customerReference' | translate }}</label>
                <input type="text" class="form-control" name="customerReference" id="customerReference" aria-describedby="customerReference" [(ngModel)]="case.customerReference">
            </div>

            <label for="asset">{{ 'pages.support.dashboard.fieldTitles.asset' | translate }}</label>

            <span class="section col-12 p-3" style="margin-bottom: 1.25rem;" [ngClass]="{'has-danger': !case.assetId && !vendor}">
                <label for="asset">{{ 'pages.support.dashboard.fieldTitles.filterAsset' | translate }}</label>
                <div class="form-group col-12 p-3">
                    <div class="form-inline">
                        <select class="form-control col-4" [(ngModel)]="vendor" [ngModelOptions]="{standalone: true}" (change)="updateAssetFilter()">
                            <option value="">Filter by Vendor</option>
                            <option value="{{vv}}" *ngFor="let vv of vendors">{{vv}}</option>
                        </select>
                        <span class="input-group-text col-1">&nbsp;</span>
                        <input type="text" class="form-control col-7" placeholder="Filter by serial number or name..." [(ngModel)]="vendorSearch" [ngModelOptions]="{standalone: true}" (keyup)='updateAssetFilter()'>
                    </div>
                </div>

                <div class="form-group col-12">
                    <select class="form-control" name="asset" aria-describedby="asset" [(ngModel)]="case.assetId" (change)="changeAsset()">
                        <option></option>
                        <option value="{{tt.id}}" *ngFor="let tt of filteredAssets">{{tt.fullName}}</option>
                    </select>
                </div>
            </span>

            <div class="form-group col-12">
                <label for="entitlement">{{ 'pages.support.dashboard.fieldTitles.service' | translate }}</label>
                <select class="form-control" name="servicename" aria-describedby="servicename" [(ngModel)]="serviceName" (change)="changeService()">
                    <option value="default"></option>
                    <option value="{{serviceName}}" *ngFor="let serviceName of serviceNames">{{serviceName}}</option>
                </select>
            </div>

            <div class="form-group col-12 pt-2">
                <label for="contact">{{ 'pages.support.dashboard.fieldTitles.contact' | translate }}</label>
                <select class="form-control" name="contact" aria-describedby="contact" [(ngModel)]="case.contactId" [ngClass]="{'has-danger': !case.contactId}">
                    <option></option>
                    <option value="{{tt.id}}" *ngFor="let tt of contacts">{{tt.fullName}}</option>
                </select>
            </div>
        </div>

        <button type="button" (click)="submit();" disabled *ngIf="!submitValid()" class="btn btn-primary">Submit</button>
        <button type="button" (click)="submit();" *ngIf="submitValid()" class="btn btn-primary">Submit</button>
      </form>
    </div>
    <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
</div>


<div class="row" *ngIf="page === 'submit'">
    <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12 p-3">
      
        <div class="row justify-content-center" *ngIf="!saved">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
            </div>
        </div>

        <div class="row justify-content-center" *ngIf="saved">
            <div class="col-12 text-center">
                <ngb-alert type="success">{{ 'pages.support.log.saved' | translate }} {{case.caseNumber}} </ngb-alert>
            </div>
        </div>

    </div>
    <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
</div>